import React, { createContext, useState } from "react";
import { authHttp } from "../services/commonHttpService";

// Create Context
const CommonContext = createContext({});

const CommonProvider = ({ children }) => {
    // Loading state
    const [isLoading, setIsLoading] = useState(false);

    // Alert state
    const [alertState, setAlertState] = useState({
        open: false,
        title: '',
        message: '',
        btnTxt: 'OK',
        cancelBtnTxt: 'No',
        status: 'success', // 'success', 'error', 'warning', 'info'
        type: 'alert', // 'alert' or 'confirm'
        onClose: null, // Optional callback function to execute when alert closes
        onConfirm: null, // Optional callback function to execute when user confirms (for type='confirm')
    });

    // Master data state
    const [masterData, setMasterData] = useState({});

    // Fetch master data from API
    const getMasterData = async (path, masterType) => {
        setIsLoading(true);
        try {
            const response = await authHttp.get(path);

            if (response?.data?.data) {
                setMasterData((previousState) => ({
                    ...previousState,
                    [masterType]: response?.data?.data,
                }));
                return response.data.data;
            }
        } catch (error) {
            // console.error(`Error fetching ${masterType}:`, error);
            setAlertState((prev) => ({
                ...prev,
                open: true,
                title: error?.response?.data?.msg,
                btnTxt: "CLOSE",
                status: "fail",
            }));
            // throw error;
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <CommonContext.Provider
            value={{
                // Loading state
                isLoading,
                setIsLoading,

                // Alert state
                alertState,
                setAlertState,

                // Master data
                masterData,
                setMasterData,
                getMasterData,
            }}
        >
            {children}
        </CommonContext.Provider>
    );
};

export { CommonContext, CommonProvider };